import { useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { WIN_CATEGORIES } from "../settings";
import { playSound } from "../State/Slices/soundsSlice";
import { SOUND_NAME } from "../sounds";
import { setWinType } from "../State/Slices/gameSettingsSlice";

// Custom hook to handle win sound logic
const useWinSound = () => {
  const dispatch = useDispatch(); // Hook to dispatch actions to the Redux store

  // Selectors to access specific parts of the Redux state
  const { currentRound } = useSelector((state) => state.game); // ✅ Use `currentRound`
  const { spinComplete, isSpinning } = useSelector((state) => state.spin); // Spin completion status

  // ✅ Use `currentRound` instead of `round[roundIndex]`
  const currentWin = useMemo(() => currentRound?.win ?? 0, [currentRound]);

  // Effect to handle sound playing based on game state changes
  useEffect(() => {
    // Only trigger if spin is complete and there is a win
    if (spinComplete && currentWin > 0 && !isSpinning) {
      // Determine the win category based on the win amount
      const category = WIN_CATEGORIES.find(
        (c) => currentWin >= c.min && currentWin < c.max
      )?.name;

      if (category) {
        dispatch(setWinType(category));
      } else {
        dispatch(playSound(SOUND_NAME.normalWin));
      }
    }
  }, [spinComplete, currentWin, dispatch, isSpinning]); // Optimized dependencies
};

// Export the custom hook for use in other components
export default useWinSound;
